const OPATRA_SUPABASE_URL = "https://baqmwkhklovqayfgiwzt.supabase.co";
const OPATRA_SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJhcW13a2hrbG92cWF5Zmdpd3p0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg4ODA5NTIsImV4cCI6MjA5NDQ1Njk1Mn0.npkRxDhbZ5B8SgMcY9D3h0rY6epwVKLnNsSpC07n-0Y";
let selectedDate = "";
let opatraBookingSubmitting = false;
function opatraShowBookingError(text, fieldToFocus) {
  const bookingBox = document.querySelector(".opatra-booking-box");
  const message = document.getElementById("opatra-booking-message");
  const dateInput = document.getElementById("opatra-booking-date");
  const timeSelect = document.getElementById("opatra-booking-time");

  if (message) {
    message.textContent = text;
    message.classList.add("opatra-booking-error-message");
  }

  if (bookingBox) {
    bookingBox.open = true;
    bookingBox.classList.add("opatra-booking-needs-attention");
    bookingBox.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  if (dateInput) dateInput.classList.toggle("opatra-booking-field-error", fieldToFocus === "date");
  if (timeSelect) timeSelect.classList.toggle("opatra-booking-field-error", fieldToFocus === "time");

  setTimeout(function () {
    if (fieldToFocus === "date" && dateInput) dateInput.focus();
    if (fieldToFocus === "time" && timeSelect) timeSelect.focus();
  }, 450);
}

function opatraClearBookingError() {
  const bookingBox = document.querySelector(".opatra-booking-box");
  const message = document.getElementById("opatra-booking-message");
  const dateInput = document.getElementById("opatra-booking-date");
  const timeSelect = document.getElementById("opatra-booking-time");

  if (bookingBox) bookingBox.classList.remove("opatra-booking-needs-attention");
  if (message) message.classList.remove("opatra-booking-error-message");
  if (dateInput) dateInput.classList.remove("opatra-booking-field-error");
  if (timeSelect) timeSelect.classList.remove("opatra-booking-field-error");
}
document.addEventListener("DOMContentLoaded", function () {
  const box = document.querySelector(".opatra-booking-box");
  if (!box) return;

  const dateInput = document.getElementById("opatra-booking-date");
  const timeSelect = document.getElementById("opatra-booking-time");
  const message = document.getElementById("opatra-booking-message");

  const slots = [
    "09:00", "09:30", "10:00", "10:30",
    "11:00", "11:30", "12:00", "12:30",
    "13:00", "13:30", "14:00", "14:30",
    "15:00", "15:30", "16:00", "16:30", "17:00", "17:30"
  ];

  let currentMonth = new Date().getMonth();
  let currentYear = new Date().getFullYear();

  const calendarWrap = document.createElement("div");
  calendarWrap.className = "opatra-month-calendar";
  dateInput.insertAdjacentElement("afterend", calendarWrap);

  function pad(number) {
    return String(number).padStart(2, "0");
  }

  function formatDate(year, month, day) {
    return year + "-" + pad(month + 1) + "-" + pad(day);
  }

  function prettyDate(date) {
    return date.toLocaleDateString("en-GB", {
      weekday: "short",
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  }

  function isPastDate(year, month, day) {
    const today = new Date();
    const testDate = new Date(year, month, day);
    today.setHours(0, 0, 0, 0);
    testDate.setHours(0, 0, 0, 0);
    return testDate < today;
  }

  function renderCalendar() {
    calendarWrap.innerHTML = "";

    const monthName = new Date(currentYear, currentMonth).toLocaleDateString("en-GB", {
      month: "long",
      year: "numeric"
    });

    const header = document.createElement("div");
    header.className = "opatra-calendar-header";

    const prevBtn = document.createElement("button");
    prevBtn.type = "button";
    prevBtn.textContent = "‹";

    const title = document.createElement("strong");
    title.textContent = monthName;

    const nextBtn = document.createElement("button");
    nextBtn.type = "button";
    nextBtn.textContent = "›";

    header.appendChild(prevBtn);
    header.appendChild(title);
    header.appendChild(nextBtn);

    const weekdays = document.createElement("div");
    weekdays.className = "opatra-calendar-weekdays";

    ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].forEach(function (day) {
      const el = document.createElement("span");
      el.textContent = day;
      weekdays.appendChild(el);
    });

    const grid = document.createElement("div");
    grid.className = "opatra-calendar-grid";

    const firstDay = new Date(currentYear, currentMonth, 1);
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

    let startBlank = firstDay.getDay() - 1;
    if (startBlank < 0) startBlank = 6;

    for (let i = 0; i < startBlank; i++) {
      const blank = document.createElement("span");
      blank.className = "opatra-calendar-empty";
      grid.appendChild(blank);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "opatra-calendar-date";
      btn.textContent = day;

      const dateValue = formatDate(currentYear, currentMonth, day);
      btn.dataset.date = dateValue;

      if (isPastDate(currentYear, currentMonth, day)) {
        btn.disabled = true;
        btn.classList.add("is-disabled");
      }

      if (selectedDate === dateValue) {
        btn.classList.add("is-selected");
      }

      btn.addEventListener("click", function () {
        selectedDate = dateValue;

        const chosenDate = new Date(currentYear, currentMonth, day);
        dateInput.value = prettyDate(chosenDate);

opatraClearBookingError();

renderCalendar();
loadTimes();
      });

      grid.appendChild(btn);
    }

    prevBtn.addEventListener("click", function () {
      const today = new Date();
      const viewingCurrentMonth =
        currentMonth === today.getMonth() &&
        currentYear === today.getFullYear();

      if (viewingCurrentMonth) return;

      currentMonth--;

      if (currentMonth < 0) {
        currentMonth = 11;
        currentYear--;
      }

      renderCalendar();
    });

    nextBtn.addEventListener("click", function () {
      currentMonth++;

      if (currentMonth > 11) {
        currentMonth = 0;
        currentYear++;
      }

      renderCalendar();
    });

    calendarWrap.appendChild(header);
    calendarWrap.appendChild(weekdays);
    calendarWrap.appendChild(grid);
  }

  async function loadTimes() {
  timeSelect.innerHTML = "";

  if (!selectedDate) {
    timeSelect.innerHTML = '<option value="">Choose a day first</option>';
    message.textContent = "Please choose your appointment day first.";
    return;
  }

  const roomType = document.getElementById("opatra-booking-room-type")?.value || "";
  const durationMinutes = parseInt(document.getElementById("opatra-booking-duration")?.value || "60");

  message.textContent = "Checking available appointment times...";

  let bookings = [];

  try {
    const response = await fetch(
      OPATRA_SUPABASE_URL +
        "/rest/v1/bookings?select=booking_time,duration_minutes,status,room_type" +
        "&room_type=eq." + roomType +
        "&status=in.(reserved,paid,completed)" +
        "&booking_date=eq." + selectedDate,
      {
        headers: {
          apikey: OPATRA_SUPABASE_ANON_KEY,
          Authorization: "Bearer " + OPATRA_SUPABASE_ANON_KEY
        }
      }
    );

    bookings = await response.json();
  } catch (error) {
    console.error(error);
  }

  timeSelect.innerHTML = '<option value="">Choose available time</option>';

  let availableCount = 0;

  slots.forEach(function (slot) {
    const slotStartText = selectedDate + " " + slot;

const [slotHour, slotMinute] = slot.split(":").map(Number);

const slotStartMinutes = slotHour * 60 + slotMinute;
const slotEndMinutes = slotStartMinutes + durationMinutes;

const hasOverlap = bookings.some(function (booking) {
  const existingTime = booking.booking_time.substring(0,5);

  const [existingHour, existingMinute] = existingTime.split(":").map(Number);

  const existingStartMinutes = existingHour * 60 + existingMinute;
  const existingEndMinutes =
    existingStartMinutes + (booking.duration_minutes || 60);

  return (
    slotStartMinutes < existingEndMinutes &&
    slotEndMinutes > existingStartMinutes
  );
});

    const option = document.createElement("option");

if (hasOverlap) {
  option.value = "";
  option.textContent = slot + " — Not available";
  option.disabled = true;
  option.className = "opatra-time-unavailable";
} else {
  option.value = slot;
  option.textContent = slot;
  availableCount++;
}

timeSelect.appendChild(option);
  });

  message.textContent =
    availableCount === 0
      ? "No available times left for this day."
      : availableCount + " appointment times available.";
}

  timeSelect.addEventListener("change", function () {
    if (selectedDate && timeSelect.value) {
  opatraClearBookingError();
  message.textContent = "Selected: " + dateInput.value + " at " + timeSelect.value;
}
  });

  renderCalendar();
});

/* Force Shopify booking add-to-cart button and hide Appointly visual button */
setInterval(function () {
  const isTreatment = document.querySelector('.opatra-booking-box');
  if (!isTreatment) return;

  const shopifyButton = document.querySelector('.product-form__submit');
  const shopifyButtonText = document.querySelector('.product-form__submit span');

  if (shopifyButton) {
    shopifyButton.style.display = 'flex';
    shopifyButton.style.visibility = 'visible';
    shopifyButton.style.opacity = '1';
    shopifyButton.removeAttribute('hidden');
    shopifyButton.removeAttribute('aria-hidden');
  }

  if (shopifyButtonText) {
    shopifyButtonText.textContent = 'Add booking to cart';
  }

  document.querySelectorAll('button, a, div').forEach(function (el) {
    const text = (el.textContent || '').trim().toLowerCase();

    if (
      text === 'schedule your time' ||
      text === 'schedule booking' ||
      text === 'book appointment' ||
      text === 'book now'
    ) {
      if (!el.classList.contains('product-form__submit')) {
        el.style.display = 'none';
      }
    }
  });
}, 300);

/* Confirm booking time and close calendar */
document.addEventListener("click", function (event) {
  const confirmButton = event.target.closest("#opatra-confirm-booking-time");
  if (!confirmButton) return;

  const bookingBox = document.querySelector(".opatra-booking-box");
  const dateInput = document.getElementById("opatra-booking-date");
  const timeSelect = document.getElementById("opatra-booking-time");
  const message = document.getElementById("opatra-booking-message");
  const summaryText = document.getElementById("opatra-booking-summary-text");

  if (!dateInput || !dateInput.value) {
    message.textContent = "Please choose your appointment day first.";
    return;
  }

  if (!timeSelect || !timeSelect.value) {
    message.textContent = "Please choose your appointment time first.";
    return;
  }

  const confirmedText = "Selected: " + dateInput.value + " at " + timeSelect.value;

  message.textContent = confirmedText;
  summaryText.textContent = confirmedText;

  if (bookingBox) {
    bookingBox.open = false;
    bookingBox.classList.add("is-confirmed");
  }
});

/* Reserve booking slot in Supabase before Shopify can add to cart */
document.addEventListener("submit", async function (event) {
  const productForm = event.target.closest('form[data-type="add-to-cart-form"]');
  if (!productForm) return;

  const bookingBox = document.querySelector(".opatra-booking-box");
  if (!bookingBox) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();
 
  if (opatraBookingSubmitting) {
  return;
}

  const dateInput = document.getElementById("opatra-booking-date");
  const timeSelect = document.getElementById("opatra-booking-time");
  const message = document.getElementById("opatra-booking-message");

  const productId = document.querySelector('input[name="properties[_Booking Product ID]"]')?.value;
  const treatmentName = document.getElementById("opatra-booking-product-title")?.value;
  const variantId = document.getElementById("opatra-booking-variant-id")?.value;
  const roomType = document.getElementById("opatra-booking-room-type")?.value;
  const reservationInput = document.getElementById("opatra-booking-reservation-id");

  let durationMinutes = parseInt(document.getElementById("opatra-booking-duration")?.value || "60");

  const variantSelect = document.querySelector('select[name="id"]');
const variantInput = document.querySelector('input[name="id"]');

if (roomType === "massage") {
  let selectedText = "";

  if (variantSelect) {
    selectedText = variantSelect.options[variantSelect.selectedIndex]?.text || "";
  }

  if (!selectedText && variantInput) {
    const selectedVariantId = String(variantInput.value || "");

    if (window.OPATRA_PRODUCT_VARIANTS && Array.isArray(window.OPATRA_PRODUCT_VARIANTS)) {
      const selectedVariant = window.OPATRA_PRODUCT_VARIANTS.find(function (variant) {
        return String(variant.id) === selectedVariantId;
      });

      if (selectedVariant) {
        selectedText = [
          selectedVariant.title,
          selectedVariant.option1,
          selectedVariant.option2,
          selectedVariant.option3
        ].filter(Boolean).join(" ");
      }
    }
  }

  selectedText = String(selectedText || "").toLowerCase();

  if (selectedText.includes("30")) durationMinutes = 30;
  else if (selectedText.includes("60")) durationMinutes = 60;
  else if (selectedText.includes("90")) durationMinutes = 90;
  else if (selectedText.includes("120")) durationMinutes = 120;
}

  if (!selectedDate || !dateInput?.value) {
  opatraShowBookingError("Please choose your preferred appointment date first.", "date");
  return;
}

if (!timeSelect?.value) {
  opatraShowBookingError("Please choose your preferred appointment time first.", "time");
  return;
}

  message.textContent = "Securing your appointment time...";

  try {
    const insertResponse = await fetch(
      OPATRA_SUPABASE_URL + "/rest/v1/bookings",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Prefer: "return=representation",
          apikey: OPATRA_SUPABASE_ANON_KEY,
          Authorization: "Bearer " + OPATRA_SUPABASE_ANON_KEY
        },
        body: JSON.stringify({
          product_id: productId,
          variant_id: variantId,
          treatment_name: treatmentName,
          booking_date: selectedDate,
          booking_time: timeSelect.value,
          room_type: roomType,
          duration_minutes: durationMinutes,
          source: "online",
          status: "reserved"
        })
      }
    );

    const data = await insertResponse.json();

    if (!insertResponse.ok) {
      message.textContent = "Sorry, this room is already booked during that time. Please choose another time.";
      loadTimes();
      return;
    }

    if (reservationInput && data[0]?.id) {
      reservationInput.value = data[0].id;
    }

    message.textContent = "Appointment secured. Adding to cart...";

opatraBookingSubmitting = true;

const formData = new FormData(productForm);

fetch("/cart/add.js", {
  method: "POST",
  body: formData
})
  .then(function (response) {
    if (!response.ok) {
      throw new Error("Cart add failed");
    }
    return response.json();
  })
  .then(function () {
    window.location.href = "/cart";
  })
  .catch(function (error) {
    console.error(error);
    opatraBookingSubmitting = false;
    message.textContent = "Could not add booking to cart. Please try again.";
  });

  } catch (error) {
    console.error(error);
    message.textContent = "Booking system error. Please refresh and try again.";
  }
}, true);